import { render } from "./EmptyStateContacts.vue?vue&type=template&id=5faadfca&scoped=true"
import script from "./EmptyStateContacts.vue?vue&type=script&lang=js"
export * from "./EmptyStateContacts.vue?vue&type=script&lang=js"

import "./EmptyStateContacts.vue?vue&type=style&index=0&id=5faadfca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faadfca"]])

export default __exports__